import React from "react";
import image1 from "../../../assets/images/osportwears/men.jpg";
const ShopNow = ({ title }) => {
  return (
    <div className="px-5 md:px-10 lg:px-20  ">
      <div className="md:flex md:justify-between md:flex-row flex-col  items-end">
        <h5 className="titlefont uppercase font-bold text-3xl">{title}</h5>
        <p className="underline">View All</p>
      </div>
      <div className="flex flex-nowrap overflow-x-scroll lg:overflow-x-hidden textfont gap-5 lg:gap-2 py-10">
        <div className="  w-60 ">
          <div className=" relative w-52 md:w-48 rounded-xl overflow-hidden group">
            <img
              src={image1}
              className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
              alt=""
            />
            <button className="z-10  uppercase translate-y-20 group-hover:translate-y-0   transition-transform duration-300  w-full group-hover:block absolute bottom-0 px-10 py-2  bg-black/20 text-xs text-white">
              quick shop
            </button>
          </div>
          <p className="font-semibold">Progress Gym Set</p>
          <p className="font-medium text-sm">50000 MMK</p>
          <p></p>
        </div>
        <div className="  w-60 ">
          <div className=" relative w-52 md:w-48 rounded-xl overflow-hidden group">
            <img
              src={image1}
              className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
              alt=""
            />
            <button className="z-10  uppercase translate-y-20 group-hover:translate-y-0   transition-transform duration-300  w-full group-hover:block absolute bottom-0 px-10 py-2  bg-black/20 text-xs text-white">
              quick shop
            </button>
          </div>
          <p className="font-semibold">Progress Gym Set</p>
          <p className="font-medium text-sm">50000 MMK</p>
          <p></p>
        </div>
        <div className="  w-60 ">
          <div className=" relative w-52 md:w-48 rounded-xl overflow-hidden group">
            <img
              src={image1}
              className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
              alt=""
            />
            <button className="z-10  uppercase translate-y-20 group-hover:translate-y-0   transition-transform duration-300  w-full group-hover:block absolute bottom-0 px-10 py-2  bg-black/20 text-xs text-white">
              quick shop
            </button>
          </div>
          <p className="font-semibold">Progress Gym Set</p>
          <p className="font-medium text-sm">50000 MMK</p>
          <p></p>
        </div>
        <div className="  w-60 ">
          <div className=" relative w-52 md:w-48 rounded-xl overflow-hidden group">
            <img
              src={image1}
              className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
              alt=""
            />
            <button className="z-10  uppercase translate-y-20 group-hover:translate-y-0   transition-transform duration-300  w-full group-hover:block absolute bottom-0 px-10 py-2  bg-black/20 text-xs text-white">
              quick shop
            </button>
          </div>
          <p className="font-semibold">Progress Gym Set</p>
          <p className="font-medium text-sm">50000 MMK</p>
          <p></p>
        </div>
        <div className="  w-60 ">
          <div className=" relative w-52 md:w-48 rounded-xl overflow-hidden group">
            <img
              src={image1}
              className="w-full -z-10 rounded-xl transition-transform duration-300 group-hover:scale-110 object-cover overflow-hidden"
              alt=""
            />
            <button className="z-10  uppercase translate-y-20 group-hover:translate-y-0   transition-transform duration-300  w-full group-hover:block absolute bottom-0 px-10 py-2  bg-black/20 text-xs text-white">
              quick shop
            </button>
          </div>
          <p className="font-semibold">Progress Gym Set</p>
          <p className="font-medium text-sm">50000 MMK</p>
          <p></p>
        </div>
      </div>
    </div>
  );
};

export default ShopNow;
